import Enum from '@/modules/core/app/helpers/Enum';

export class MessageSentiment extends Enum {
  key!: string;
  value!: string;

  static POSITIVE: MessageSentiment = {
    key: 'positive',
    value: '😊'
  };

  static NEUTRAL: MessageSentiment = {
    key: 'neutral',
    value: ''
  };

  static MIXED: MessageSentiment = {
    key: 'mixed',
    value: '🫤'
  };

  static NEGATIVE: MessageSentiment = {
    key: 'negative',
    value: '😡'
  };
}
